import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Result, Button } from "antd";
import { useAuth } from "../../context/AuthContext";

// Tenant-admin gate (USER_LEVEL_CLIENT_ASSIGNMENT.md §3.2 / §7.5).
// Allows `tenant_admin` and `super_admin` (the latter has implied admin
// rights everywhere). Blocks regular `user`, `read_only`, and the
// partner_admin role (partner_admin operates on the dedicated
// /partner-admin surface, not the tenant Team page).
//
// Mirror of <AdminRoute /> — same redirect-to-/login when not authed +
// same 403 result page for forbidden roles. Distinct file so the
// `super_admin`-only AdminRoute keeps its narrower contract; this one
// widens to admin-or-tenant-admin.

const TENANT_ADMIN_ROLES = new Set(["tenant_admin", "super_admin"]);

const TenantAdminRoute = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!TENANT_ADMIN_ROLES.has(user.role)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <Result
          status="403"
          title="403 - Forbidden"
          subTitle="You do not have permission to access team management."
          extra={
            <Button type="primary" href="/">
              Back to dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return <Outlet />;
};

export default TenantAdminRoute;
